module.exports = __webpack_public_path__ + "img/create-board-icon.8c256dcc.svg";